import styled from 'styled-components'
import * as colors from '@bufferapp/ui/style/colors'

import { flexCol } from '~/shared/styles/layout'

/**
 *
 */

// @ts-expect-error TS(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
const getServiceColor = (type) => colors[type] || '#000000'

const { gray, white } = colors

/**
 *
 */
export const Wrapper = styled.div`
  width: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'size' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    props.size}px;
  position: relative;
`

export const AvatarWrapper = styled.div`
  ${flexCol}
  justify-content: center;
  width: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'size' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    props.size}px;
  height: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'size' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    props.size}px;
  background-color: ${gray};
  border-radius: 50%;
  color: ${white};

  & svg:hover {
    color: ${white};
    fill: ${white};
  }
`

export const ServiceIndicator = styled.div`
  ${flexCol}
  justify-content: center;
  width: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'size' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    props.size + 4}px;
  height: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'size' does not exist on type 'ThemedStyl... Remove this comment to see the full error message
    props.size + 4}px;
  position: absolute;
  bottom: 0;
  right: 0;
  color: ${colors.white};
  background-color: ${(props) =>
    getServiceColor(
      // @ts-expect-error TS(2339) FIXME: Property 'service' does not exist on type 'ThemedS... Remove this comment to see the full error message
      props.service,
    )};
  border: 2px solid ${colors.white};
  border-radius: 50%;
`
